$(function () {

    updateScrollProgress();

    $('.tabs nav li').click(function () {
        var tabIndex = $(this).index();
        $('.tabs nav li').removeClass('active');
        $(this).addClass('active');

        $('.tabs ul.tabs li.tab').removeClass('active');
        $('.tabs ul.tabs li.tab').eq(tabIndex).addClass('active');
    });

    $(window).on("scroll", function () {
        updateScrollProgress();
    })

    function updateScrollProgress() {
        if ($("ul").hasClass("tabs")) {
            var top = $(".tabs nav").offset().top - $(this).scrollTop();
            var currentProgress = 0;

            if (top <= 0) {
                $(".tabs nav").addClass("scrolled");
                currentProgress = (($(this).scrollTop() - $(".tabs").offset().top)) / ($(".tabs").height() - $(".tabs nav").height());

                $(".tabs nav #nav-tab-progress").width(Math.floor(currentProgress * 100) + "%")

            } else {
                $(".tabs nav").removeClass("scrolled");
                $(".tabs nav #nav-tab-progress").width(0)
            }
        }
    }
});